module.exports = __webpack_public_path__ + "img/24 waltzes front cover.195570ec.jpg";